import { useParams } from 'react-router';
import { DashboardProvider } from '../../contexts';
import { DashboardContent } from '../dashboard-content';

export const AccountDashboard = () => {
  const { sourceId } = useParams<{ sourceId: string }>();

  return (
    <DashboardProvider sourceId={sourceId}>
      <DashboardContent />
    </DashboardProvider>
  );
};
